<ng-container *ngTemplateOutlet="inputTemplate; context: { value, onValueChange  }">
</ng-container>
